import { Button } from "@mui/material";
import { aiChallengeURL } from "@src/urls";
import * as React from "react";

interface AiChallengeRegisterButtonProps {
  tall?: boolean;
  playNow?: boolean;
}

const AiChallengeRegisterButton: React.FC<AiChallengeRegisterButtonProps> = ({
  tall = false,
  playNow = false,
}) => {
  return (
    <Button
      variant="contained"
      sx={{
        height: tall ? "52px" : "auto",
        paddingX: {
          md: "16px",
          lg: "32px",
        },
      }}
      href={
        playNow
          ? aiChallengeURL
          : "/landing/ai-escape-room/#ai-challenge-registration"
      }
    >
      {playNow ? "Play now!" : "Register now"}
    </Button>
  );
};

export default AiChallengeRegisterButton;
